import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { SelectField, TextField, Loadable } from "components/support";

export default class FilterView extends Component {
  static inventories = [
    { value: "all", label: "Todo o estoque" },
    { value: "positive", label: "Estoque positivo" },
    { value: "zero", label: "Estoque zerado" },
    { value: "negative", label: "Estoque negativo" }
  ];

  constructor(props) {
    super(props);

    this.state = {
      type: "all",
      code: "",
      name: ""
    };
  }

  async handleChange(field, value) {
    const { onFilter } = this.props;
    this.setState({ [field]: value }, () => onFilter(this.state));
  }

  render() {
    const { type, code, name } = this.state;

    return (
      <Paper elevation={1} className="p-sm mb-md">
        <Typography type="headline">Filtro</Typography>
        <Loadable loading={this.props.loading}>
          <Row>
            <Col xs={12} md={12} lg={4}>
              <SelectField
                fullWidth
                label="Tipo de Estoque"
                value={type}
                onChange={(_, value) => this.handleChange("type", value)}
                options={FilterView.inventories}
              />
            </Col>
            <Col xs={12} md={6} lg={4}>
              <TextField
                fullWidth
                value={code}
                label="Código"
                onChange={(_, value) => this.handleChange("code", value)}
              />
            </Col>
            <Col xs={12} md={6} lg={4}>
              <TextField
                fullWidth
                value={name}
                label="Nome do Produto"
                onChange={(_, value) => this.handleChange("name", value)}
              />
            </Col>
          </Row>
        </Loadable>
      </Paper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/product/inventory/filter/index.jsx